export default {
    title: 'Your request is being processed.'
}
